import * as React from "react";
import { Datagrid, FunctionField, ListProps, TextField } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { FC } from "react";
import { DefaultCreatedDateSort, DefaultPerPageSize } from "../../../Constants/Constant";
import { SourceRequestStatusInfo } from "./Constant/Source";
import { useAccessControl } from "@airborne/react-admin";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const useDatagridStyles = makeStyles({
  total: { fontWeight: "bold" },
});

const sort = { field: "requestStatus", order: "ASC" };

const RequestStatusInfoList: FC<ListProps> = props => {
  const { canCreate, canEdit, canRead, hasAccess } = useAccessControl(SourceRequestStatusInfo);

  return (
    <PoolList
      {...props}
      sort={DefaultCreatedDateSort}
      perPage={DefaultPerPageSize}
      resource={SourceRequestStatusInfo}
      bulkActionButtons={false}
      title="REQUEST STATUS INFO"
    >
      <Datagrid rowClick={canEdit ? "edit" : ""}>
        <FunctionField
          style={{ fontSize: 12 }}
          label="Status"
          render={(record: any) => Math.floor(record.requestStatus / 10)}
        />
        <TextField source="displayName" label="Display Name" />
      </Datagrid>
    </PoolList>
  );
};

export default RequestStatusInfoList;
